import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DOMPurify from 'dompurify';

// Components
import Video from '../Modules/Video';

const BVReview = observer(class BVReview extends React.Component {
  componentWillMount() {
    const { SessionStore, StepInStore } = this.props.store;

    if(SessionStore.loadingCalls.indexOf('BVData') < 0) {
      StepInStore.getBVData(this.props.examSid, this.props.sessionSid);
    }
  }

  initials(name, className) {
    const names = name.split(' ');
    const firstInitial = names[0].charAt(0);
    const secondInitial = names[1].charAt(0);

    if(className) {
      return `${firstInitial.toLowerCase()}`
    }

    return firstInitial + secondInitial;
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { userTimezone } = this.props.store.SessionStore;
    const { metadata } = this.props.store.StepInStore;

    if(!SessionStore.loading && metadata) {
      return (
        <div className="videos">
          <section className="panel__section panel__section--half">
            <h2 className="panel__heading">{translation.desktop}</h2>

            <Video
              src={`https://s3.amazonaws.com/${metadata.bucket}${metadata.bomgar_video_path}`}
              controls={true}
              autoplay={false}
              {...this.props}
            />
          </section>

          <section className="panel__section panel__section--half">
            <h2 className="panel__heading">{translation.chat}</h2>

            <ol className="chat conversation">
              {metadata.chat.map(
                (message, i) => {
                  let fromUser = message.performed_by.name.split(' ');

                  if(fromUser.length === 1) {
                    fromUser.push(' ');
                  }

                  return(
                    <li key={i}>
                      <blockquote className={`
                        conversation__message
                        ${message.performed_by.type === 'customer' ? 'sent' : 'received'}
                      `}>
                        <div className="conversation__body">
                          <div className="conversation__content">
                            <div dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(message.body.replace(/\r?\n|\r/g, ' '))}
                            }></div>
                          </div>

                          <time className="conversation__timestamp">
                            {moment.unix(message.timestamp).tz(userTimezone).format('M/D/YYYY h:mma z')}
                          </time>
                        </div>

                        <cite className="conversation__author conversation__author--sm">
                          <abbr
                            className={`
                              avatar--initials conversation__avatar ${this.initials(fromUser[0] + ' ' + fromUser[1], true)}
                            `}
                            title={`${fromUser[0]} ${fromUser[1]}`}>
                            {fromUser[0].charAt(0)}{fromUser[1].charAt(0)}
                          </abbr>
                        </cite>
                      </blockquote>
                    </li>
                  )
                }
              )}
            </ol>
          </section>

          <section className="panel__section">
            <h2 className="panel__heading">{translation.webcams}</h2>

            {metadata.mega_meeting &&
              <div className="vid-holder">
                {metadata.mega_meeting.map(
                  (video, i) =>
                  <Video
                    key={i}
                    src={`https://s3.amazonaws.com/${video.bucket}${video.path}`}
                    controls={true}
                    autoplay={false}
                    {...this.props}
                  />
                )}
              </div>
            }
          </section>
        </div>
      );
    }

    return null;
  }
})

export default translate('BVReview')(BVReview);



// WEBPACK FOOTER //
// ./src/app/components/Sessions/BVReview.js